import { useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  DatePicker,
  Divider,
  Flex,
  Input,
  Select,
  Table,
} from 'antd';
import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  getPurchaseAnalytics,
  getStockAnalytics,
  getStockLedgerReport,
} from '../../network/stockLedgerReport';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getSearchApi } from '../../network/itemList';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const PurchaseAnalytics = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    warehouse: '',
    item_code: '',
    stock_uom: '',
    voucher_no: '',
  });
  console.log(sourceData, 'sourceData');

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getPurchaseAnalytics,
      currentLang,
      currentLang,
      sourceData.from_date,
      sourceData.to_date,
    ],
    queryFn: () =>
      getPurchaseAnalytics(
        currentLang,
        companyName,
        sourceData.from_date,
        sourceData.to_date
      ),
  });
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));
  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );

  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.inventory} subTitle={t.PurchaseAnalytics} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Flex
          style={{
            // justifyContent: 'space-between',
            gap: '20px',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <RangePicker
            format="YYYY/MM/DD"
            style={{ width: '100%' }}
            placeholder={['From Date', 'To Date']}
            // defaultValue={[dayjs().isBefore(dayjs().add(4, 'month')), dayjs()]}
            defaultValue={[dayjs().startOf('year'), dayjs()]}
            value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
            onChange={(dates, dateStrings) => {
              setSourceData({
                from_date: dateStrings[0],
                to_date: dateStrings[1],
              });
            }}
          />
        </Flex>
        <Divider orientation="left">{t.PurchaseAnalytics}</Divider>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          // summary={() => (
          //   <Table.Summary.Row>
          //     {totalRow?.map((value, index) => (
          //       <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
          //     ))}
          //   </Table.Summary.Row>
          // )}
        />
      </Card>
    </div>
  );
};

export default PurchaseAnalytics;
